import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'db-create-migrate',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './create-migrate.component.html',
    styleUrls: ['./create-migrate.component.scss'],
    standalone: false
})
export class CreateMigrateComponent implements OnInit {

  @Input() managerLink: string;
  @Input() productId: string;
  @Output() openDialog: EventEmitter<string> = new EventEmitter<string>();
  @Output() download: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private _router: Router
  ) { }

  ngOnInit() {
  }

  downloadManagerPlugin(): void {
    this.download.emit();
    this._router.navigate(['/migration-steps']).then();
  }
}
